import { Theme } from '@mui/material/styles'

import { BRAND_ACCENT, BRAND_ACCENT_HOVER } from '../brandColors'

// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function Button(theme: Theme) {
  return {
    MuiButton: {
      defaultProps: {},
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '8px',
          gap: '8px',
          lineHeight: '20px',
          fontWeight: 600,
          '& .MuiButton-startIcon': {
            marginRight: 0,
            marginLeft: 0,
            fontSize: '10px',
          },
        },
      },
      variants: [
        {
          props: { size: 'medium' },
          style: {
            padding: '12px 18px',
            height: '40px',
            fontSize: '14px',
          },
        },
        {
          props: { color: 'secondary', variant: 'contained' },
          style: {
            backgroundColor: BRAND_ACCENT,
            color: theme.palette.secondary.contrastText,
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: BRAND_ACCENT_HOVER,
              color: theme.palette.secondary.contrastText,
            },
          },
        },
      ],
    },
    MuiButtonGroup: {
      defaultProps: {},
      styleOverrides: {
        root: {
          '& .MuiButton-root': {
            borderColor: theme.palette.primary.light,
          },
        },
      },
    },
  }
}
